"use client";

import { c as _c } from "react/compiler-runtime";
import { CourseCard } from "@/components/common/course-card";
import { RenderIf } from "@/components/common/render-if";
import { SliderPagination } from "@/components/common/slider-pagination";
import { StartLearningWithSpoclearnLoader } from "@/components/loadings/start-learning-with-spoclearn-loader";
import { Section } from "@/components/section";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GET_SERVICE_BY_TYPE, SERVICE_TYPE_OPTIONS, ServiceType } from "@/graphql/queries/service-by-type-query";
import { useQuery } from "@apollo/client/react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";
type StartLearnWithSpoclearnProps = {
  section: PageSections;
  data?: {
    heading: string;
    seoHeading?: string;
    buttonText: string;
    buttonAction: string;
    startLearningWithSpoclearn: ServiceByTypeInterface[];
  };
};
const getTagLabel = (tag: ServiceType) => {
  switch (tag) {
    case ServiceType.IS_POPULAR:
      return "Popular Course";
    case ServiceType.IS_CERTIFICATION_PROGRAM:
      return "Certification Program";
    case ServiceType.IS_SKILL_BASED_COURSES:
      return "Skill-based Course";
    default:
      return "";
  }
};
const StartLearningWithSpoclearn = t0 => {
  const $ = _c(66);
  const {
    section,
    data
  } = t0;
  const {
    country: countryParam
  } = useParams();
  const [api, setApi] = useState();
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [tag, setTag] = useState(ServiceType.IS_POPULAR);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  let t1;
  if ($[0] !== api) {
    t1 = value => {
      setTag(value);
      api?.scrollTo(0);
    };
    $[0] = api;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleTagChanges = t1;
  const t2 = Boolean(countryParam) && tag === ServiceType.IS_POPULAR;
  let t3;
  if ($[2] !== countryParam || $[3] !== tag) {
    t3 = {
      serviceType: tag,
      countryCode: countryParam
    };
    $[2] = countryParam;
    $[3] = tag;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      skip: t2,
      variables: t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data: clientData,
    loading
  } = useQuery(GET_SERVICE_BY_TYPE, t4);
  let t5;
  let t6;
  if ($[8] !== api) {
    t5 = () => {
      if (!api) {
        return;
      }
      const onSelect = () => {
        setCount(api.scrollSnapList().length);
        setCurrent(api.selectedScrollSnap());
        setCanScrollPrev(api.canScrollPrev());
        setCanScrollNext(api.canScrollNext());
      };
      onSelect();
      api.on("select", onSelect);
      return () => {
        api.off("select", onSelect);
      };
    };
    t6 = [api];
    $[8] = api;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  const t7 = `${section.sectionClass} dark:bg-background bg-gray-100`;
  const t8 = data?.heading;
  const t9 = data?.seoHeading;
  const t10 = data?.buttonText;
  const t11 = data?.buttonAction;
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <TabsList className="bg-background ring-border dark:bg-muted hidden ring md:block">{SERVICE_TYPE_OPTIONS.map(_temp)}</TabsList>;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== handleTagChanges) {
    t13 = value_0 => handleTagChanges(value_0 as ServiceType);
    $[12] = handleTagChanges;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SelectTrigger className="w-full sm:max-w-48" aria-label="Course Type"><SelectValue /></SelectTrigger>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SelectContent alignItemWithTrigger={false} align="start"><SelectGroup>{SERVICE_TYPE_OPTIONS.map(_temp2)}</SelectGroup></SelectContent>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t13 || $[17] !== tag) {
    t16 = <div className="w-full md:hidden"><Select items={SERVICE_TYPE_OPTIONS} value={tag} onValueChange={t13}>{t14}{t15}</Select></div>;
    $[16] = t13;
    $[17] = tag;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  const t17 = !canScrollPrev;
  let t18;
  if ($[19] !== api) {
    t18 = () => api?.scrollPrev();
    $[19] = api;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  let t20;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ChevronLeft />;
    t20 = <span className="sr-only">Previous slide</span>;
    $[21] = t19;
    $[22] = t20;
  } else {
    t19 = $[21];
    t20 = $[22];
  }
  let t21;
  if ($[23] !== t17 || $[24] !== t18) {
    t21 = <Button disabled={t17} onClick={t18}>{t19}{t20}</Button>;
    $[23] = t17;
    $[24] = t18;
    $[25] = t21;
  } else {
    t21 = $[25];
  }
  const t22 = !canScrollNext;
  let t23;
  if ($[26] !== api) {
    t23 = () => api?.scrollNext();
    $[26] = api;
    $[27] = t23;
  } else {
    t23 = $[27];
  }
  let t24;
  let t25;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <ChevronRight />;
    t25 = <span className="sr-only">Next slide</span>;
    $[28] = t24;
    $[29] = t25;
  } else {
    t24 = $[28];
    t25 = $[29];
  }
  let t26;
  if ($[30] !== t22 || $[31] !== t23) {
    t26 = <Button disabled={t22} onClick={t23}>{t24}{t25}</Button>;
    $[30] = t22;
    $[31] = t23;
    $[32] = t26;
  } else {
    t26 = $[32];
  }
  let t27;
  if ($[33] !== t21 || $[34] !== t26) {
    t27 = <div className="hidden gap-1 sm:flex">{t21}{t26}</div>;
    $[33] = t21;
    $[34] = t26;
    $[35] = t27;
  } else {
    t27 = $[35];
  }
  let t28;
  if ($[36] !== t16 || $[37] !== t27) {
    t28 = <div className="flex items-center gap-2 sm:justify-between">{t12}{t16}{t27}</div>;
    $[36] = t16;
    $[37] = t27;
    $[38] = t28;
  } else {
    t28 = $[38];
  }
  let t29;
  if ($[39] !== handleTagChanges || $[40] !== t28) {
    t29 = <Tabs defaultValue={ServiceType.IS_POPULAR} onValueChange={handleTagChanges}>{t28}</Tabs>;
    $[39] = handleTagChanges;
    $[40] = t28;
    $[41] = t29;
  } else {
    t29 = $[41];
  }
  let t30;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      align: "start",
      slidesToScroll: "auto",
      skipSnaps: true
    };
    $[42] = t30;
  } else {
    t30 = $[42];
  }
  const t31 = !loading;
  let t32;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <StartLearningWithSpoclearnLoader />;
    $[43] = t32;
  } else {
    t32 = $[43];
  }
  const t33 = countryParam && tag === ServiceType.IS_POPULAR ? data?.startLearningWithSpoclearn : clientData?.serviceByType;
  let t34;
  if ($[44] !== t33 || $[45] !== tag) {
    t34 = <CarouselContents data={t33} tag={tag} />;
    $[44] = t33;
    $[45] = tag;
    $[46] = t34;
  } else {
    t34 = $[46];
  }
  let t35;
  if ($[47] !== t31 || $[48] !== t34) {
    t35 = <Carousel opts={t30} className="mt-4 w-full" setApi={setApi}><RenderIf condition={t31} fallback={t32}>{t34}</RenderIf></Carousel>;
    $[47] = t31;
    $[48] = t34;
    $[49] = t35;
  } else {
    t35 = $[49];
  }
  let t36;
  if ($[50] !== api) {
    t36 = i => api?.scrollTo(i);
    $[50] = api;
    $[51] = t36;
  } else {
    t36 = $[51];
  }
  let t37;
  if ($[52] !== count || $[53] !== current || $[54] !== t36) {
    t37 = <SliderPagination current={current} count={count} onChange={t36} />;
    $[52] = count;
    $[53] = current;
    $[54] = t36;
    $[55] = t37;
  } else {
    t37 = $[55];
  }
  let t38;
  if ($[56] !== section.sectionId || $[57] !== t10 || $[58] !== t11 || $[59] !== t29 || $[60] !== t35 || $[61] !== t37 || $[62] !== t7 || $[63] !== t8 || $[64] !== t9) {
    t38 = <Section className={t7} id={section.sectionId} title={t8} seoTitle={t9} actionLabel={t10} path={t11}>{t29}{t35}{t37}</Section>;
    $[56] = section.sectionId;
    $[57] = t10;
    $[58] = t11;
    $[59] = t29;
    $[60] = t35;
    $[61] = t37;
    $[62] = t7;
    $[63] = t8;
    $[64] = t9;
    $[65] = t38;
  } else {
    t38 = $[65];
  }
  return t38;
};
export default StartLearningWithSpoclearn;
type CarouselContentsProps = {
  data?: ServiceByTypeInterface[];
  tag: ServiceType;
};
const CarouselContents = t0 => {
  const $ = _c(7);
  const {
    data: t1,
    tag
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  let t3;
  if ($[2] !== data || $[3] !== tag) {
    t3 = data?.map(course => <CarouselItem key={course.id} className="basis-1/1 sm:basis-1/2 lg:basis-1/3"><CourseCard tag={getTagLabel(tag) || "Popular"} name={course.name} image={course.service_image || course.serviceImage} imageProps={{
        loading: "eager"
      }} serviceId={course.id} totalEnroll={course.numberOfLearners} duration={course.serviceTrainingDays} slug={course.slug} accreditation_name={course.accreditation_name} icon={course.serviceIcon} modeOfTraining={course.mode_of_training || "Live Classroom / Classroom"} currency={course.currency} sellingPriceNumber={course.price} serviceFlags={course.serviceFlags} isGenericPageOnly={course.isGenericPageOnly} /></CarouselItem>);
    $[2] = data;
    $[3] = tag;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <CarouselContent>{t3}</CarouselContent>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp(item) {
  return <TabsTrigger key={item.value} value={item.value} className="data-active:bg-primary data-active:text-primary-foreground data-active:hover:text-primary-foreground">{item.label}</TabsTrigger>;
}
function _temp2(item_0) {
  return <SelectItem key={item_0.value} value={item_0.value}>{item_0.label}</SelectItem>;
}